import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  DestroyRef,
  inject,
  ViewChild,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

interface Participant {
  initials: string;
  name: string;
  color: string;
}

interface Message {
  id: string;
  author: string;
  initials: string;
  color: string;
  content: string;
  timestamp: string;
  date: string;
  isOwn: boolean;
}

@Component({
  selector: "app-conversation-thread",
  templateUrl: "./conversation-thread.component.html",
  styleUrls: ["./conversation-thread.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationThreadComponent {
  @Input() conversationId!: string;
  @Output() backToList = new EventEmitter<void>();

  @ViewChild("threadMessages") threadMessagesRef?: ElementRef<HTMLElement>;

  private destroyRef = inject(DestroyRef);

  // Données mock
  conversationTitle = "Équipe Chantier Lilas";
  participants: Participant[] = [
    { initials: "PD", name: "Pauline Douce", color: "pink" },
    { initials: "SH", name: "Simao Henriques", color: "blue" },
    { initials: "ML", name: "Marc Lemoine", color: "green" },
  ];

  messages: Message[] = [
    {
      id: "1",
      author: "Pauline Douce",
      initials: "PD",
      color: "pink",
      content: "Bonjour à tous, on fait le point sur le planning de la semaine ?",
      timestamp: "10:15",
      date: "Aujourd'hui",
      isOwn: false,
    },
    {
      id: "2",
      author: "Marc Lemoine",
      initials: "ML",
      color: "green",
      content: "Oui parfait ! Je suis disponible vendredi matin pour la réunion de coordination.",
      timestamp: "10:23",
      date: "Aujourd'hui",
      isOwn: false,
    },
    {
      id: "3",
      author: "Vous",
      initials: "ME",
      color: "purple",
      content: "Super, je note ça. On se retrouve à 9h au bureau ?",
      timestamp: "10:30",
      date: "Aujourd'hui",
      isOwn: true,
    },
    {
      id: "4",
      author: "Simao Henriques",
      initials: "SH",
      color: "blue",
      content: "Ok pour le planning, je confirme ma présence vendredi 🚀",
      timestamp: "14:52",
      date: "Aujourd'hui",
      isOwn: false,
    },
  ];

  newMessage = "";

  onBack() {
    this.backToList.emit();
  }

  sendMessage() {
    if (!this.newMessage.trim()) return;

    // TODO: Appel API
    this.messages.push({
      id: Date.now().toString(),
      author: "Vous",
      initials: "ME",
      color: "purple",
      content: this.newMessage,
      timestamp: new Date().toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }),
      date: "Aujourd'hui",
      isOwn: true,
    });

    this.newMessage = "";

    // Scroll to bottom
    setTimeout(() => {
      const el = this.threadMessagesRef?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    }, 50);
  }
}
